<div [id]="id" class="callout lighter-gray" *ngIf="show">
  <p id="{{'dialog' + id + 'Desc'}}" class="description" [innerHTML]="advisor + '.' + id + '_text' | translate"></p>
</div>
